import { SubsectionHeader } from "./SubsectionHeader";

// Renamed and changed to boolean: 'imageOnRight'
const Subsection = ({ 
  id = '', 
  title = 'Title', 
  subline = 'Subline', 
  image = null, 
  imageOnRight = false, // <-- NEW BOOLEAN PROP (default left)
  dataAos = 'fade', 
  children = null, 
  dataAosDelay, 
  dataAosDuration 
}) => {
  
  const containerClasses = "container mx-auto dpr-max-w-container font-light text-xl leading-snug md:flex md:gap-16";
  const contentWidthClass = image ? "md:w-3/4" : "w-full";

  // Image Classes: Sets the order to LAST if imageOnRight is true
  const imageOrderClass = imageOnRight ? 'md:order-last' : 'md:order-first';
  const imageWrapperClasses = `md:w-1/4 flex-shrink-0 mb-2 md:mb-0 mx-auto mt-4 md:mt-2 ${imageOrderClass}`;
  const imageSize = "w-[193px] h-auto "; 

  // Content Classes: Sets the order to FIRST if imageOnRight is true (content moves left)
  const contentOrderClass = imageOnRight ? 'md:order-first' : 'md:order-last';

  return (
    <section id={id} className="pt-8 pb-4 px-6 mb-0 md:px-0">
      <div
        className={containerClasses}
        data-aos={dataAos}
        data-aos-delay={dataAosDelay}
        data-aos-duration={dataAosDuration ? dataAosDuration : undefined}
      >
        
        {/* Content (Text, Header, and Children) */}
        <div className={`${contentWidthClass} ${contentOrderClass}`}> 
          <SubsectionHeader 
              subline={subline} 
              headline={title} 
            />
          {children}
        </div>

        {/* Image */}
        {image && (
          <div className={`${imageWrapperClasses} ${imageSize}`}>
            {image}
          </div>
        )}
        
      </div>
    </section>
  );
};

export { Subsection };